export default __webpack_public_path__ + "6285828c14f4aa2f16c8c33133fe6afe.jpg";